document.addEventListener('DOMContentLoaded', () => {
  let container = document.querySelector('.hp-hero__start-items');
  let animatedFinalWrapper = document.querySelector('.hp-hero__animation-final');
  let animatedFinalClone = document.querySelector('.hp-hero__animation-final-clone');
  let animatedItemsWrapper = document.querySelector('.hp-hero__animation-start');
  let desktopAnimatedDescription = document.querySelector('.hp-hero__description-text');
  let desktopAnimatedDescriptionWrapper = document.querySelector('.hp-hero__description');
  let desktopAnimatedReviews = document.querySelector('.hp-hero__reviews');
  let heroAnimationWrapper = document.querySelector('.hp-hero__animation');
  let finalTl = gsap.timeline({ repeat: 0 });
  let counter = 0;

  gsap.ticker.lagSmoothing(false);
  gsap.defaults({ ease: 'power1.inOut' });

  function animateItemsGSAP() {
    let items = document.querySelectorAll('.animation-item');

    if (container && items) {
      let firstItem = items[0];

      firstItem.classList.add('falling');

      gsap.to(firstItem, {
        duration: 0.7,
        y: container.clientHeight - firstItem.clientHeight,
        onComplete: () => {
          setTimeout(() => {
            firstItem.classList.remove('falling');
          }, 0);

          container.appendChild(firstItem);

          gsap.set(firstItem, { y: 1 });

          if (counter >= container.dataset.count) {
            finalizeAnimation(items);
          }
        }
      });

      for (let i = 1; i < items.length; i++) {
        //after 1st element drop, rest of elements going up
        gsap.to(items[i], {
          duration: 0.7,
          y: -items[i].offsetHeight,
          onComplete: () => {
            gsap.set(items[i], { y: 0 });
          }
        });
      }

      counter++;
    }
  }

  function finalizeAnimation(items) {
    clearInterval(animateItemsGSAPInterval);

    if (animatedFinalWrapper && animatedFinalClone && animatedItemsWrapper) {
      for (let i = 0; i < items.length; i++) {
        //removing all elements except 1st
        if (i !== 1) {
          gsap.delayedCall(0.6, () => {
            gsap.to(items[i], {
              duration: 0.3,
              opacity: 0,
              onComplete: () => {
                gsap.to(items[i], { duration: 0.5, height: 0 });
                gsap.to(animatedItemsWrapper, { duration: 0.5, height: animatedFinalClone.clientHeight });
              }
            });
          });
        }
      }
      //First item coming closer to the static element
      //and both elements going out of screen + disappearing
      gsap.delayedCall(1, () => {
        finalTl.to(items[1], { duration: 0.7, x: -12 })
          .add( () => {

            gsap.to(animatedItemsWrapper, { duration: 0.35, opacity: 0 })

            if (window.innerWidth >= 1024) {
              gsap.to([desktopAnimatedDescriptionWrapper, desktopAnimatedReviews], {
                duration: 0.35,
                opacity: 0
              })
            }
          }, ">")
          .add(() => {
            gsap.set(animatedFinalWrapper, { duration: 0.35, display: 'flex' });
            gsap.fromTo(animatedFinalWrapper, { opacity: 0 }, { duration: 0.35, opacity: 1 });

            animatedItemsWrapper.classList.add('hidden');

            if (window.innerWidth >= 1024) {
              gsap.set([desktopAnimatedDescription, desktopAnimatedDescriptionWrapper, desktopAnimatedReviews], {
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center"
              });
              gsap.set(desktopAnimatedDescription, { width: 400 });
              gsap.set(heroAnimationWrapper, { justifyContent: "center" });

              gsap.to([desktopAnimatedDescriptionWrapper, desktopAnimatedReviews], {
                duration: 0.35,
                opacity: 1
              });
            }
          }, "+=0.35")
          .add(() => {
            ScrollTrigger.refresh()
            finalTl.kill();
          }, ">");
      });
    }
  }

  //auto-start animation 1500
  let animateItemsGSAPInterval = setInterval(animateItemsGSAP, 1500);
});
